import { EClassicHistoryMode } from '../../../enums';

export type TClassicHistoryMode = EClassicHistoryMode.ALL | EClassicHistoryMode.MY;
